<template>
  <div class="ViewProfileRemoveAccount">
    <app-button-control
      type="border-grey-light"
      @click="openRemoveAccountCurtain"
      class="ViewProfileRemoveAccount__btn"
    >
      Удалить аккаунт
    </app-button-control>
  </div>
</template>

<script>
import { rootMapper } from '@/store/root';

export default {
  name: 'ViewProfileRemoveAccount',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
  },

  methods: {
    ...rootMapper.mapMutations(['SET_REMOVE_ACCOUNT_CURTAIN']),
    /**
     * Открытие шторки удаления аккаунта
     */
    openRemoveAccountCurtain() {
      this.$modal.show('main-curtain');
      this.SET_REMOVE_ACCOUNT_CURTAIN(true);
    },
  },
};
</script>

<style lang="scss">
.ViewProfileRemoveAccount {
  &__btn {
    min-width: 252px;
    font-weight: 600;
    color: #000;
    text-transform: uppercase;
  }
}
</style>
